import React from 'react';
import '../QuienesSomos/QuienesSomos.css';
import './CatedraOMC.css';
import { Link } from 'react-router-dom';
import PageBanner from '../../layout/PageBanner';
import Card from './Card';

const CatedraOMC = (props) => (
  <div >
    <PageBanner title="Cátedra OMC" img="banner-OMC.jpg">
      <Link to="/">Home</Link>
      <Link to="/catedra-omc">Cátedra OMC</Link>
    </PageBanner>

    <section className="about-ds">
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2><span>Cátedra </span>OMC</h2>
            </div>
            <p className="fade-in" dangerouslySetInnerHTML={{ __html: props.textCatedra }}></p>
          </div>
          <div className="col-md-5 col-sm-6 about-ds-image">
            <img src={props.imageCatedra} alt="" className="img-responsive"/>
          </div>
        </div>
      </div>
    </section>

    <section className="all-course-wrapper courses-11">
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-sm-6 about-ds-content">
            <div className="section-header03">
              <h2>Cursos <span>y Seminarios</span></h2>
            </div>
          </div>
          <div className="col-md-12">
            <div className="course11-blocks">
              <div className="row">
                {props.staffCatedraOMC.length > 0 &&
                  props.staffCatedraOMC.map((card,index) =>
                    <Card
                      mainState={card}
                      type='omc'
                      fromTitle="Cátedra OMC"
                      fromLink="/catedra-omc"
                      key={`card${index}`}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
);

export default CatedraOMC;
